export * from './sidebar.directive';



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/app/directives/sidebar/index.ts